import { render, staticRenderFns } from "./DetentionButtons.vue?vue&type=template&id=703531e6&"
import script from "./DetentionButtons.vue?vue&type=script&lang=js&"
export * from "./DetentionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports